// extracted by mini-css-extract-plugin
export default {"passport":"passport_passport__4If3J","item":"passport_item__kUiFs","label":"passport_label__uSMhs","val":"passport_val__XZ7V5"};